// extracted by mini-css-extract-plugin
module.exports = {"container":"styles_container__3WYT9","content":"styles_content__FhNGL","buttonIcon":"styles_buttonIcon__2GUx3"};